// src/components/Error403.jsx
import React from "react";
import history from "../../history";
import { Button } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Error403.css";

const Error403 = () => {
	const goToHome = () => {
		history.push("/#/dashboard");
		window.location.reload();
	};

	return (
		<div className="error-403-container">
			<h1 className="error-403-title">403 - Forbidden</h1>
			<p className="error-403-message">
				Você não tem permissão para acessar esta página.
			</p>
			<Button
				color="primary"
				onClick={goToHome}
				className="error-403-button"
			>
				Voltar à Tela Inicial
			</Button>
		</div>
	);
};

export default Error403;
